export const types = {
    MEDIA_RESOURCES_SET_CACHED_SOURCE: 'MEDIA_RESOURCES_SET_CACHED_SOURCE',
    MEDIA_RESOURCES_SET_ERRORED_SOURCE: 'MEDIA_RESOURCES_SET_ERRORED_SOURCE',
    MEDIA_RESOURCES_SET_LOADED_SOURCE: 'MEDIA_RESOURCES_SET_LOADED_SOURCE',
};

const mediaResourcesActions = {
    types,

    setCachedSource(identifier, url) {
        return { type: types.MEDIA_RESOURCES_SET_CACHED_SOURCE, identifier, url };
    },

    setErroredSource(identifier, url, crossOrigin) {
        return { type: types.MEDIA_RESOURCES_SET_ERRORED_SOURCE, identifier, url, crossOrigin };
    },

    setLoadedSource(identifier, url, crossOrigin) {
        return { type: types.MEDIA_RESOURCES_SET_LOADED_SOURCE, identifier, url, crossOrigin };
    },
};

export default mediaResourcesActions;
